import { Http } from '@angular/http';
import { Inject, Injectable } from '@angular/core';
import { ApiErrorHandler } from 'tridion.web.ui/src/app/angular/api/error/ApiErrorHandler';
import { ENVIRONMENT } from 'tridion.web.ui/src/app/angular/environment/ENVIRONMENT';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { BaseTPWApi } from './BaseTPWApi';
import { ITpwSample } from '../../../../model/product/tena/tpw/ITpwSample';
import { IEnvironment } from '../../../../environment/IEnvironment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TpwSampleApi extends BaseTPWApi<ITpwSample> {
    constructor(
        apiErrorHandler: ApiErrorHandler,
        authService: AuthService,
        @Inject(ENVIRONMENT) environment: IEnvironment,
        http: Http,
        public httpClient: HttpClient
    ) {
        super(apiErrorHandler, authService, environment, http);
    }

    getSampleList() {
        // Json file path 'dist/assets/json/sampleList.json'

        return this.httpClient.get('./assets/json/sampleList.json');
    }

    protected getBaseUrl() {
        return this.TPWBaseURl + 'SampleOrder/GetSampleCategories';
    }
}
